module.exports = __webpack_public_path__ + "img/_history_log.a8472b39.svg";